export default "__VITE_ASSET__BtqWXVaw__"